export default __webpack_public_path__ + "64da1c91fb8373b4f0e5c1292026c15f.svg";